/*
  userInfo.js-是vuex的一个module，用来存放当前登录人的个人信息。
  by.qiushangzhe 2020-01-22
*/
const state = {
  name: null, // 用户显示的名字
  isGEC: null, // 是不是GEC的员工
  role: null, // 用户的角色
  organizationName: null // 机构的名称
}

const getters = {
  isLogin (state) {
    const { name } = state
    return name !== null && name !== undefined && name !== ''
  },
  roleName (state) {
    const { vuexUserRole } = state
    if (vuexUserRole === 'producerLeader') { return '总监' }
    if (vuexUserRole === 'producerStaff') { return '专员' }
    return null
  }
}

const mutations = {
  SET_USER_INFO (state, data) {
    const { name, isGEC, role, organizationName } = data
    state.name = name
    state.isGEC = isGEC
    state.role = role
    state.organizationName = organizationName
  }
}

// 异步操作
const actions = {
  // 用户信息监测
  initUserInfo ({ commit }, data) {
    commit('SET_USER_INFO', data)
  }
}
export default { namespaced: true, state, getters, mutations, actions }
